"use client";

// import type { Metadata } from "next";
import "./globals.css";
import "@anu-its/ts-react-components/dist/index.css";
import NavBar from "@/app/components/NavBar";
import React, { useEffect } from "react";
import { Footer, Header } from "@anu-its/ts-react-components";
import ReactQueryProvider from "./providers/ReactQueryProvider";
import { env } from "./env";
import "../app/sites/[site_id]/site-details.css";
import { useUserStore } from "@/app/providers/UserStore";

const isProd = env.NEXT_PUBLIC_ENVIRONMENT === "prod";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const initializeAuth = useUserStore((state) => state.initializeAuth);

  useEffect(() => {
    const unsubscribe = initializeAuth();

    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, [initializeAuth]);

  const additionalLinks = [
    {
      href: "https://anu365.sharepoint.com/sites/DigitalPlanHub/SitePages/CAT-App-resource.aspx",
      label: "Docs",
    },
  ];
  return (
    <html lang="en">
      <body className="anu-body__wrapper">
        <ReactQueryProvider>
          <div className=" relative z-10">
            {!isProd && (
              <div className="py-1 w-full text-center bg-red-600 text-white">
                Development Environment
              </div>
            )}
            <a href="#main-content" className="skip-link">
              Skip to main content
            </a>
            <Header heading={{ label: "Courses and Teachers", href: "/" }} />
            <NavBar />
          </div>
          <main
            id="main-content"
            role="main"
            className="flex mt-10 justify-between items-start grow"
          >
            {children}
          </main>
          <div className="relative z-10">
            <Footer slim={true} additionalLinks={additionalLinks} />
          </div>
        </ReactQueryProvider>
      </body>
    </html>
  );
}
